import React from 'react'
import { jt, t } from 'ttag'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import aboutCE from '@h2/assets/svg/about/aboutCE.svg'
import journeyEN from '@h2/assets/svg/about/journeyEN.svg'

import { useTitleChange } from '../../util/hooks'

const About = () => {
  useTitleChange(t`About ${dynamicValues.systemName}`)

  const onetLicenseLink = (
    <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>
  )
  const onetDBLink = (
    <a href="https://www.onetcenter.org/database.html">O*NET 26.2 Database</a>
  )
  const ppLink = (
    <a href="https://www.powerschool.com/privacy-statement-overview/">{t`Privacy Statement`}</a>
  )

  return (
    <div className="container about-content">
      <h3 className="bordered section-heading">
        <span>{t`About the Platform`}</span>
      </h3>

      <p>{t`The ${dynamicValues.systemName} site is powered by Headed2, a secure web-based platform designed to help you explore, plan, and prepare for a career you’ll love.`}</p>

      <p>{t`Using our innovative technology, you are afforded an end-to-end career discovery journey. By working through the system, you can access:`}</p>

      <img
        src={aboutCE}
        aria-hidden="true"
        alt={t`About the career explorer`}
        style={{ maxWidth: '30%' }}
        className="pull-right"
      />

      <ul className="about-features">
        <li className="self-assess">{t`Self-assessment modules including interest, work-importance and skills profile tools.`}</li>
        <li className="financial-literacy">{t`Financial literacy tools including our popular “Budget your Life” assessment`}</li>
        <li className="occs-colleges">{t`Over 900 occupations, as well as information on US colleges and certifications`}</li>
        <li className="personal-pathway">{t`Personalized pathway recommendations based on student exploration`}</li>
      </ul>

      <p className="clear">{jt`If you are interested in the consumer data collected by this site and how it is used please view our ${ppLink}.`}</p>

      <br className="clear" />
      <h3 className="section-heading bordered">
        <span>{t`About Headed2`}</span>
      </h3>
      <img
        src={journeyEN}
        aria-hidden="true"
        alt={t`Illustrative map of the milestones in the company history`}
        style={{ maxWidth: '30%' }}
        className="pull-right"
      />
      <p>
        {t`For over 15 years, Headed2 has been helping students plan for their future and explore the world of work. In that time, we have grown into a reliable and robust 
        platform that services millions of individuals each year from across the United States.`}
      </p>

      <h3 className="section-heading">{t`Our Mission`}</h3>
      <p>
        {t`At Headed2, we believe in the democratization of career information. For too long, career guidance and planning was an afterthought, and only talked about in the 
        context of what to do after college. By offering world class planning tools, coupled with detailed information for research, and financial literacy tools for validating 
        their plans, the Headed2 CareerExplorer helps to make sure that students have access to tools and information to help them succeed. At Headed, we believe that the planning
         they do in school is only just the beginning of a students’ career journey… that’s why we give students access to our planning tools for life.`}
      </p>

      <h3 className="bordered section-heading">
        <span>{t`Credits`}</span>
      </h3>
      <p>
        <a href="https://www.onetcenter.org/database.html">
          <img
            src="https://www.onetcenter.org/image/link/onet-in-it.svg"
            style={{ width: '130px', height: '60px', border: 'none' }}
            alt="O*NET in-it"
          />
        </a>
      </p>
      <p>{jt`This page includes information from the ${onetDBLink} by the U.S. Department of Labor, Employment and Training Administration (USDOL/ETA). Used under the ${onetLicenseLink} license. O*NET\u00AE is a trademark of USDOL/ETA.`}</p>
    </div>
  )
}

export default connect(
  _ => ({}),
  dispatch => ({ dispatch })
)(About)
